import { Box, Button, Heading, Image, Text } from "@chakra-ui/react"
import { Generator } from "../QRGenreator/Generator"
import { Selector_nth } from "../Selector/Selector_nth"
import uimaster from '../../assets/uimaster.jpg'
import { useNavigate } from "react-router-dom"


export const Home = () => {
    const navigate = useNavigate()

    return (
        <Box>
            <Box>
                <Box display={'flex'} gap={'10px'} p={'10px'}>
                    <Text color={'#F44336'} fontSize={'30px'} fontWeight={'bold'}>|| </Text>
                    <Text color={'#373131'} fontSize={'30px'} fontWeight={'bold'}>Ui Master</Text>
                </Box>

                <Box textAlign={'center'} color={'#373131'} p={'1cm 0'} m={'.5cm auto'}>
                    <Heading>Simplify Web Development with</Heading>
                    <Box display={'flex'} gap={'7px'} w={'fit-content'} m={'auto'}>
                        <Heading m={'10px auto'} fontSize={'25px'}>Our Styling</Heading>
                        <Heading m={'10px auto'} color={'#F44336'} fontSize={'25px'}>Tools</Heading>
                    </Box>
                </Box>

                <Box w={['90%', '85%', 'fit-content']} bg={'#757575'} m={'1cm auto'} p={'10px'} display={'flex'} flexDirection={['column']} justifyContent={'space-between'} boxShadow={'rgba(0, 0, 0, 0.24) 0px 3px 8px'} borderRadius={'15px'}>
                    <Image cursor={'pointer'} display={'block'} m={'auto'} onClick={() => navigate('/UiMaster/GridGenerator')} src={uimaster} h={'400px'} borderRadius={'10px'} alt="uimaster" />
                    <Box>
                        <Box fontSize={['14px', '15px', '100%']} color={'white'} p={'10px'} mt={['10px', '15px', '20px']}>
                            Grid Generator can make Grid boxes faster than before. Customize you grid and take grid in different formats.
                        </Box>
                        <Button bg={'#000544'} onClick={() => navigate('/UiMaster/GridGenerator')} color={'white'} w={'200px'} mt={'15px'} mb={'10px'} ml={'10px'}>Try Now</Button>
                    </Box>
                </Box>


                <Box w={['90%', '85%', '70%']} bg={'#757575'} m={'1cm auto'} p={'10px'} display={'flex'} flexDirection={['column', 'column', 'row']} justifyContent={'space-between'} boxShadow={'rgba(0, 0, 0, 0.24) 0px 3px 8px'} borderRadius={'15px'}>
                    <Box textAlign={'center'} w={['100%', '100%', '45%']} fontSize={'20px'} fontWeight={'medium'} p={'10px'}>
                        <Text fontSize={['14px', '15px', '17px']} color={'white'} mt={['10px', '15px', '20px']}>This is a QR Generator, Here you have to past any link, text, or number then click on that button and it will generate a QR Code</Text>
                        <Button bg={'#00E676'} color={'#000544'} w={'200px'} mt={'20px'} mb={'10px'}>GET CODE</Button>
                    </Box>
                    <Box w={['100%', '100%', '55%']}><Generator /></Box>
                </Box>

                <Box w={['95%', '90%', '85%', '60%']} m={'auto'}>
                    <Selector_nth />
                </Box>
            </Box>
        </Box>
    )
}